import { TFR, TFRFailure, TFRSuccess } from "./TaskFunctionResponses.js";
import { EInternalTaskIds, ETaskFunctionEndId, } from "./TaskFunctionTypes.js";
import { _getEndIdForHttpStatusCode, _getHttpStatusCodeForEndId, } from "./TaskFunctionUtils/_getHttpStatusCodeForEndId.js";
export function hasEndTags(response, ...tags) {
    for (const tag of tags) {
        if (response.endTags.indexOf(tag) === -1) {
            return false;
        }
    }
    return true;
}
export function isPositive(response) {
    return response.positive;
}
export function isNegative(response) {
    return !response.positive;
}
export async function runTaskFunctionOnObject(obj, key, ...args) {
    const func = obj[key];
    if (func == null) {
        return TFR({
            positive: false,
            endId: ETaskFunctionEndId.NOT_FOUND,
            errorPayload: null,
            payload: null,
            endMessage: `Function not found for key: ${key.toString()} in ${obj.constructor.name}`,
            endTags: [],
            taskId: EInternalTaskIds.util_run_task_function_on_object,
        });
    }
    return await func(...args);
}
// TODO remove and place into @gt/server
export function apiResponseTFR(ctx, taskFunctionResponse) {
    ctx.body = taskFunctionResponse;
    ctx.type = "application/json";
    ctx.status = taskFunctionResponse.positive ? 200 : 500;
}
export function fractionalFeedback(defaultUnit, defaultLimit) {
    return (current, limit = defaultLimit, unit = defaultUnit) => ({
        unit,
        current,
        limit,
    });
}
export function convertErrorToTFR(e) {
    let response;
    if (e instanceof TaskFunctionError) {
        response = e.taskFunctionResponse;
    }
    else {
        response = TFRFailure(ETaskFunctionEndId.THROWN_ERROR, e.message, e);
    }
    return response;
}
export class TaskFunctionError extends Error {
    taskFunctionResponse;
    constructor(negativeResponse) {
        if (negativeResponse.endMessage) {
            super(negativeResponse.endMessage);
        }
        else {
            super("Something went wrong.");
        }
        this.taskFunctionResponse = {
            ...TFRFailure(ETaskFunctionEndId.ERROR),
            ...negativeResponse,
        };
    }
    errorString() {
        return TaskFunctionUtils.printTaskFunctionError(this.taskFunctionResponse);
    }
}
export class EmptyObserver {
    __isEmptyObserver = true;
    _hideWarnings;
    constructor(hideWarnings = false) {
        this._hideWarnings = hideWarnings;
    }
    hideWarnings(hideWarnings) {
        this._hideWarnings = hideWarnings;
    }
    complete() {
        if (!this._hideWarnings) {
            console.warn(`Calling empty observer.complete(). Should only be for internal processes.`);
        }
    }
    error(err) {
        if (!this._hideWarnings) {
            console.warn(`Calling empty observer.error(). Should only be for internal processes.`);
        }
    }
    next(value) {
        if (!this._hideWarnings) {
            console.warn(`Calling empty observer.next(). Should only be for internal processes.\n ProgressUpdate: ${value.status} : ${value.action} : ${value.message}`);
        }
    }
}
export var ETFRKoaEndpointSetStatus;
(function (ETFRKoaEndpointSetStatus) {
    ETFRKoaEndpointSetStatus["FROM_END_ID"] = "FROM_END_ID";
    ETFRKoaEndpointSetStatus["ALWAYS_200"] = "ALWAYS_200";
    ETFRKoaEndpointSetStatus["DONT_AFFECT"] = "DONT_AFFECT";
})(ETFRKoaEndpointSetStatus || (ETFRKoaEndpointSetStatus = {}));
export function TFRKoaEndpoint(func, { status = ETFRKoaEndpointSetStatus.ALWAYS_200 } = {}) {
    return async (ctx) => {
        const resp = await func(ctx);
        ctx.body = resp;
        ctx.type = "application/json";
        if (status !== ETFRKoaEndpointSetStatus.DONT_AFFECT) {
            ctx.status =
                status === ETFRKoaEndpointSetStatus.FROM_END_ID
                    ? _getHttpStatusCodeForEndId(resp.endId)
                    : 200;
        }
    };
}
export function getValidationResponse(schema, values) {
    // const validationResult = Joi.validate(values, schema, { stripUnknown: true });
    const validationResult = schema.validate(values, { stripUnknown: true });
    // Joi.validate(values, schema, { stripUnknown: true });
    if (validationResult.error !== null) {
        return TFRFailure(ETaskFunctionEndId.ILLEGAL_ARGUMENT, `Parameter Validation Failed: ${validationResult.error} ]`);
    }
    return TFRSuccess({ arguments: validationResult.value });
}
export function getPositivePayloadOrThrow(response) {
    if (response.positive) {
        return response.payload;
    }
    throw new Error(`Task Function: getPositiveResponseOrThrow(), did throw: ${response.endId} - ${response.endMessage}`);
}
function printTaskFunctionError(error) {
    return `message("${error.endMessage}") endId(${error.endId}) taskId(${error.taskId ?? "_"}) tags(${error.endTags.join(", ")})`;
}
export const TaskFunctionUtils = {
    getHttpStatusCodeForEndId: _getHttpStatusCodeForEndId,
    getEndIdForHttpStatusCode: _getEndIdForHttpStatusCode,
    getEmptyObserver: (hideWarnings = false) => new EmptyObserver(hideWarnings),
    runTaskFunctionOnObject,
    apiResponseTFR,
    getValidationResponse,
    printTaskFunctionError,
};
